import * as React from "react";
import { useParams } from "react-router-dom";

import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderTabs } from "../../../molecules/service-provider-tab";
import { ServiceProviderR } from "../routes";
import { PrimaryButton } from "@graffer-inc/console-design-kit";
import {
  AiStudioContextProps,
  AiStudioService,
} from "../../../../application/service/service-provider/aistudio-service";

export const AiStudio: React.FC<AiStudioContextProps> = ({
  isAvailable,
  fetchOrgProducts,
}) => {
  const { id: orgId } = useParams<{ id: string }>();
  React.useEffect(() => {
    fetchOrgProducts(orgId);
  }, [fetchOrgProducts, orgId]);

  return (
    <ServiceProviderTemplate
      breadcrumbs={[{ to: ServiceProviderR.Home.link({}), title: "Home" }]}
    >
      <ServiceProviderTabs orgId={orgId} />
      <nav className="level">
        <div className="level-left">
          <p className="level-item">
            {isAvailable && (
              <a
                href={`${
                  process.env.REACT_APP_ENVIRONMENT === "local"
                    ? "http://localhost:4901"
                    : window.location.origin
                }/aistudio/sp/${orgId}`}
              >
                <PrimaryButton text="AI Studioの設定画面を開く" />
              </a>
            )}
          </p>
        </div>
      </nav>
      {!isAvailable && (
        <div className="columns">
          <div className="column">
            <div className="box">
              <div className="content">
                <p>
                  このテナントでは、AI Studioを利用できません。
                  <br />
                  AI Studioの
                  <a href={ServiceProviderR.Products.link({ id: orgId })}>
                    製品設定
                  </a>
                  をご確認ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </ServiceProviderTemplate>
  );
};

export const AiStudioContainer = connectPageService(
  AiStudio,
  () => new AiStudioService(),
);
